<template>
	<div class="form__group">
		<multiselect
            :options="options"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="name"
            track-by="id"
            :multiple="multiple"
            :show-labels="false"
            v-model="selected"
            :class="{
                'form__control': true,
                'form__control--invalid': errors.first(this.name)
            }"
        />
		<label class="form__label">{{ label }}</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlCountry',
		mixins: [Select],
		props: {
			label: {
				type: String,
				default: 'Country',
			},
			name: {
				type: String,
				default: 'country',
			},
			placeholder: {
				type: String,
				default: 'Select a country...',
			},
		},
		data() {
			return {
				options: window.countries || [],
			}
		},
	}
</script>

